import script from "./QuickLinkManager.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickLinkManager.vue?vue&type=script&setup=true&lang=js"

import "./QuickLinkManager.vue?vue&type=style&index=0&id=01cd91f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01cd91f4"]])

export default __exports__